// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3_sci","header":"ReportDetails_header__1Jks0","title":"ReportDetails_title__KXQBo","left":"ReportDetails_left__wORLY"};